module.exports = __webpack_public_path__ + "static/media/card.cd4dbf4a.svg";